import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Button as AvonButton } from '@avon/component-library';
import { func, object } from 'prop-types';
import warningIcon from '../assets/warningIcon.svg';
import { isMobile } from '../../../utils/getDeviceType';
import HomeContext from '../../../home/HomeContext';

const useStyles = makeStyles(() => ({
  wrapper: e => (e.isMobile ? {
    padding: '40px 16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 64,
      height: 64,
    },
  } : {
    padding: '60px 60px 53px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 84,
      height: 84,
    },
  }),
  title: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '22px',
    lineHeight: '30px',
    textAlign: 'center',
    color: '#F09F87',
    margin: '30px 0 12px',
  } : {
    fontFamily: 'Montserrat-Light',
    fontSize: '42px',
    lineHeight: '54px',
    textAlign: 'center',
    color: '#F09F87',
    margin: '18px 0 24px',
  }),
  desc: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#707677',
  } : {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    lineHeight: '26px',
    textAlign: 'center',
    color: '#546264',
  }),
}));

const WarningDetail = ({
  setclickId,
  notifycationDetail: {
    contentMap, apptId, category, rejected,
  },
  redirectTo,
  snsInfo: { button, info = {} },
}) => {
  const classes = useStyles({ language: 'not ar', isMobile: isMobile() });
  const [, dispatch] = useContext(HomeContext);

  return (
    <Box className={classes.wrapper}>
      <img
        src={warningIcon}
        alt="success-icon"
      />
      <Box className={classes.title}>
        {info[category]}
      </Box>
      {
        contentMap && contentMap.content0 && (
          <Box className={classes.desc}>
            {contentMap.content0}
          </Box>
        )
      }
      {
        contentMap && contentMap.content1 && (
          <Box className={classes.desc}>
            {contentMap.content1}
          </Box>
        )
      }
      {isMobile()
        ? (
          <Box style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'column',
            marginTop: 48,
          }}
          >
            {
            !rejected && (
              <Box flex={1}>
                <AvonButton
                  priority="secondary"
                  onClick={() => {
                    dispatch({ currentPage: 'leads' });
                    redirectTo({
                      type: 'lma', subType: 'leads', hasFooter: false, params: `apptId=${apptId}`,
                    });
                  }}
                >
                  {button && button.viewLead}
                </AvonButton>
              </Box>
            )
          }
            <Box flex={1} mt={3}>
              <AvonButton
                priority="tertiary"
                onClick={() => setclickId('')}
              >
                {button && button.close}
              </AvonButton>
            </Box>
          </Box>
        )
        : (
          <Box style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'row-reverse',
            marginTop: 48,
          }}
          >
            {
            !rejected && (
              <Box flex={1} style={{ width: '50%' }}>
                <AvonButton
                  priority="secondary"
                  onClick={() => {
                    dispatch({ currentPage: 'leads' });
                    redirectTo({
                      type: 'lma', subType: 'leads', hasFooter: false, params: `apptId=${apptId}`,
                    });
                  }}
                >
                  {button && button.viewLead}
                </AvonButton>
              </Box>
            )
          }
            <Box flex={1} style={{ width: '50%', paddingRight: 10 }}>
              <AvonButton
                priority="tertiary"
                onClick={() => setclickId('')}
              >
                {button && button.close}
              </AvonButton>
            </Box>
          </Box>
        )
      }
    </Box>
  );
};

WarningDetail.propTypes = {
  notifycationDetail: object,
  setclickId: func,
  redirectTo: func,
  snsInfo: object,
};

export default WarningDetail;
